import React, { useEffect, useRef, useState } from "react";
import {
  Checkbox,
  Form,
  Input,
  InputNumber,
  Modal,
  Select,
  Spin,
  Tooltip,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { saveFileUpload } from "../../../../../features/save/saveSlice";
import {
  fetchLeaveType,
  fetchNdovupayWallet,
  fetchStaffGrade,
} from "../../../../../features/dropdown/dropdownSlice";
import { paymentMethodsData } from "../../../../../data";
import { setSinglePaymentObj } from "../../../../../features/folder/folderSlice";
import VerificationModal from "./VerificationModal";
import svg59 from "../../../../../assets/svg/svg59.svg";
import svg60 from "../../../../../assets/svg/svg60.svg";
import deleteRed from "../../../../../assets/svg/delete-red.svg";

import bankTemplate from "../../../../../assets/temp/NDOVUPAYBANKTEMPLATE.xlsx";
import mpesaTemplate from "../../../../../assets/temp/NDOVUPAYMPESATEMPLATE.xlsx";

const { TextArea } = Input;

const BulkPaymentModal = ({
  open,
  handleCancel,
  handleFetchData,
  setopenSingle,
}) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

   
  const { saving,loading } = useSelector((state) => state.save);
  const { singlePaymentObj } = useSelector((state) => state.folder);
  const { ndovuWallet  } = useSelector((state) => state.dropdown);

  const [openVerification, setopenVerification] = useState(false);
  async function handleCancelVerification() {
    await setopenVerification(false);
    await setopenSingle(true);
  }
  async function handleOpenVerification() {
    await setopenVerification(true);
    await setopenSingle(false);
    await handleCancel();
  }

  async function handleCancelSingle() {
    await handleCancel();
    await form.resetFields();
    await setShow();
  }

  const [file, setFile] = useState();
  const [formData, setFormData] = useState();
  const [show, setShow] = useState(singlePaymentObj?.paymentMethod);
 

  async function fetchNdovupayWalletData() {
    await dispatch(fetchNdovupayWallet());
  }

  const collectionWallet =
  ndovuWallet && ndovuWallet?.find((item) => item?.walType === "COLLECTION");


  const onFinish = async (data) => {
    // await dispatch(setSinglePaymentObj(data));
    // await handleOpenVerification();
    const formData = new FormData();
    if (file) {
      formData.append("file", file);
    } else {
      toast.error("File is null or undefined");
      return;
    }
    const res = await dispatch(
      saveFileUpload({
        formData,
        url: `py/uploadBulkPayment.action?pdTransType=${data?.pdTransType}&paymentDescription=${data.paymentDescription}`,
      })
    ); 
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.messsage);
      await handleFetchData();
      await setFormData({});
      await handleCancel();
      await form.resetFields();
      await setFile("");
    } else {
      toast.error(res?.payload?.messages?.messsage);
    }
  };

  useEffect(() => {
    fetchNdovupayWalletData(); 
  }, []);

  useEffect(() => {
    setShow(singlePaymentObj?.paymentMethod);
  }, [singlePaymentObj?.paymentMethod]);

  
  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={`Upload Bulk Payment`}
        open={open}
        onOk={onFinish}
        onCancel={handleCancelSingle}
        width={850}
        maskClosable={false}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
          // initialValues={singlePaymentObj}
        >
          <Form.Item
            name="pdTransType"
            className=""
            label={<span>Payment Method</span>}
            rules={[
              {
                required: true,
                message: "Please select payment method",
              },
            ]}
          >
            <Select
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                paymentMethodsData?.length > 0 &&
                paymentMethodsData?.map((item) => ({
                  value: item?.value,
                  label: item?.label,
                }))
              }
              onChange={(value) => {
                setShow(value);
              }}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              onDropdownVisibleChange={() => {}}
            />
          </Form.Item>
          {show === "BANK" ? (
            <>
              <a href={bankTemplate} type="button" download>
                <div className=" flex items-end">
                  <Tooltip title="Download file ">
                    <img src={svg59} alt="svg59" />
                  </Tooltip>
                  <span className="ml-3 text-[15px] font-bold font-dmSans">
                    Click to download bank template
                  </span>
                </div>
              </a>

              <div className="dropzone-wrapper mt-5 mb-5">
                <div className="dropzone-desc">
                  <img className="" src={svg60} alt="svg60" />
                  <p className="ant-upload-text text-[#7E93AE] text-[14px] font-[400]">
                    Drag & Drop or{" "}
                    <span className="text-[#010101] font-[500]">
                      Choose file
                    </span>{" "}
                    to upload
                  </p>
                  <p className="ant-upload-hint text-[#010101] font-[500]">
                    .xlsx
                  </p>
                </div>
                <input
                  accept=".xls,.xlsx"
                  onChange={(e) => setFile(e.target.files[0])}
                  type="file"
                  name="file"
                  className="dropzone"
                />
              </div>

              {file?.name && (
                <div className="flex items-center justify-between my-2">
                  <p className="text-[16px] f0nt-[600] text-[#010101] w-[80%] truncate">
                    {file?.name}
                  </p>
                  <img
                    src={deleteRed}
                    alt="deleteRed"
                    onClick={() => setFile(null)}
                    className="text-[red] text-[25px] cursor-pointer"
                  />
                </div>
              )}
            </>
          ) : show === "MPESA" ? (
            <>
              <a href={mpesaTemplate} type="button" download>
                <div className=" flex items-end">
                  <Tooltip title="Download file ">
                    <img src={svg59} alt="svg59" />
                  </Tooltip>
                  <span className="ml-3 text-[15px] font-bold font-dmSans">
                    Click to download mpesa template
                  </span>
                </div>
              </a>

              <div className="dropzone-wrapper mt-5 mb-5">
                <div className="dropzone-desc">
                  <img className="" src={svg60} alt="svg60" />
                  <p className="ant-upload-text text-[#7E93AE] text-[14px] font-[400]">
                    Drag & Drop or{" "}
                    <span className="text-[#010101] font-[500]">
                      Choose file
                    </span>{" "}
                    to upload
                  </p>
                  <p className="ant-upload-hint text-[#010101] font-[500]">
                    .xlsx
                  </p>
                </div>
                <input
                  accept=".xls,.xlsx"
                  onChange={(e) => setFile(e.target.files[0])}
                  type="file"
                  name="file"
                  className="dropzone"
                />
              </div>

              {file?.name && (
                <div className="flex items-center justify-between my-2">
                  <p className="text-[16px] f0nt-[600] text-[#010101] w-[80%] truncate">
                    {file?.name}
                  </p>
                  <img
                    src={deleteRed}
                    alt="deleteRed"
                    onClick={() => setFile(null)}
                    className="text-[red] text-[25px] cursor-pointer"
                  />
                </div>
              )}
            </>
          ) : null}
           <Form.Item
                name="paymentDescription"
                label="Reason for transfer"
                rules={[
                  {
                    required: true,
                    message: "Enter reason for transfer",
                  },
                ]}
              >
                <TextArea
                  rows={4}
                  placeholder="Enter reason for transfer"
                  className="input-textarea"
                />
              </Form.Item>

          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancelSingle}
                  className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn"
                  disabled={loading}
                >
                  {loading ? <Spin /> : "Submit"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
      <VerificationModal
        handleFetchData={handleFetchData}
        open={openVerification}
        setopenVerification={setopenVerification}
        handleCancel={handleCancelVerification}
      />
    </>
  );
};
export default BulkPaymentModal;
